import { HeaderCreateHookProps } from "./headerCreateType";

export function useHeaderCreate({result, loading, setType} : HeaderCreateHookProps) {
    const handleSelectType = (newType: "ticket" | "user" | "organization") => {
        if (!(result && Object.keys(result).length > 0) && !loading) {
            setType(newType);
        }
    };

    const variableDisabledCss = `${(result && Object.keys(result).length > 0) || loading ? "disabled" : ""}`

    return{
        handleSelectType, 
        variableDisabledCss
    }
}